import type { NewsItem } from "@/types/catalog";

export const newsList: NewsItem[] = [
  {
    id: "n001",
    title: "《长风渡月》口碑逆袭登顶，古装权谋剧为何再度迎来春天",
    summary: "开播首周讨论度持续走高，《长风渡月》凭借扎实的剧本与群像塑造，成为本季度最受关注的古装剧。",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20editorial%20photo%20of%20ancient%20Chinese%20palace%20courtyard%20at%20night%20with%20warm%20lantern%20light%20and%20falling%20petals%2C%20deep%20navy%20and%20amber%20tones%2C%20elegant%20atmospheric%20film%20still%2C%20highly%20detailed&width=800&height=500&seq=news-cover-001&orientation=landscape",
    date: "2025-10-14",
    category: "剧集观察",
    author: "爱妻艺编辑部",
    views: 386,
    tags: ["长风渡月", "古装剧", "口碑"],
    content: [
      "近段时间，古装剧市场再度热闹起来。其中，《长风渡月》开播首周便登上多个平台热度榜首，社交平台相关话题阅读量持续攀升。",
      "与不少同类型作品不同，《长风渡月》并未过度依赖感情线推进，而是把大量篇幅放在朝堂博弈与边关战事上。少年将军与女官的双线成长，让整部剧的节奏紧凑而不失层次。",
      "业内人士分析，观众对古装剧的审美正在回归理性。扎实的剧本、经得起推敲的人物动机，以及群像角色的立体塑造，正在成为决定一部剧能否长线发酵的关键。",
      "值得一提的是，该剧在服化道与场景调度上也颇下功夫。无论是边关的风沙，还是京城的夜雨，都让观众产生了较强的沉浸感。",
      "随着剧情进入后半程，多条线索即将交汇。《长风渡月》能否延续现有口碑，值得继续关注。",
    ],
  },
  {
    id: "n002",
    title: "科幻片《深海回声》定档，国产硬科幻再添新作",
    summary: "影片以深海科考为背景，聚焦一段跨越八十年的神秘声呐信号，将在下月全国公映。",
    cover: "https://readdy.ai/api/search-image?query=Deep%20ocean%20sci-fi%20film%20still%2C%20a%20research%20submersible%20descending%20into%20a%20dark%20trench%20lit%20by%20bioluminescent%20glow%2C%20deep%20blue%20and%20cyan%20tones%2C%20cinematic%20suspenseful%20underwater%20atmosphere%2C%20highly%20detailed&width=800&height=500&seq=news-cover-002&orientation=landscape",
    date: "2025-10-13",
    category: "电影速递",
    author: "光影观察员",
    views: 302,
    tags: ["深海回声", "科幻", "定档"],
    content: [
      "国产科幻片《深海回声》正式宣布定档，将于下月全国公映。影片由顾星河执导，讲述一支深海科考队在马里亚纳海沟接收到神秘声呐信号的故事。",
      "从此前曝光的预告片来看，影片在水下场景的呈现上投入了大量精力。幽暗的海沟、发光的生物群，以及压抑的空间感，营造出强烈的悬疑氛围。",
      "导演顾星河在采访中表示，影片想探讨的并非单纯的未知恐惧，而是人类在面对未知时如何彼此信任。这一内核让作品在类型之外多了几分温度。",
      "近年来，国产科幻不断在题材与技术上寻求突破。《深海回声》能否延续这一势头，将成为下半年影市的一大看点。",
    ],
  },
  {
    id: "n003",
    title: "这档慢综艺凭什么治愈了千万观众",
    summary: "《向往的生活季》用一日三餐与四季更替，在快节奏时代里为观众提供了一处情绪出口。",
    cover: "https://readdy.ai/api/search-image?query=Peaceful%20farmhouse%20in%20the%20countryside%20at%20dusk%2C%20warm%20amber%20windows%20and%20chimney%20smoke%2C%20vegetable%20gardens%20and%20distant%20mountains%2C%20soft%20green%20and%20navy%20tones%2C%20serene%20editorial%20photography%2C%20highly%20detailed&width=800&height=500&seq=news-cover-003&orientation=landscape",
    date: "2025-10-12",
    category: "综艺精选",
    author: "爱妻艺编辑部",
    views: 268,
    tags: ["向往的生活季", "慢综艺", "治愈"],
    content: [
      "在快节奏的生活里，一档没有激烈冲突、只记录日常的节目，却意外收获了极高的关注度。《向往的生活季》用最朴素的方式，打动了无数观众。",
      "节目中，嘉宾们种菜、做饭、招待朋友，几乎没有剧本。正是这种真实感，让观众得以暂时抽离现实压力，获得片刻的放松。",
      "有观众在评论区留言：看他们做饭、聊天，就像自己也回到了乡下，心一下子就静了下来。",
      "综艺市场的细分正在加速。当竞技类节目不断加码刺激感时，慢综艺则选择往情绪深处走，用陪伴感建立与观众的长期连接。",
    ],
  },
  {
    id: "n004",
    title: "年度悬疑剧《暗夜追凶》制作特辑曝光，细节控看过来",
    summary: "剧组公开幕后制作特辑，从剧本打磨到场景搭建，展现了悬疑类型剧的工业化制作水准。",
    cover: "https://readdy.ai/api/search-image?query=Dark%20suspense%20behind-the-scenes%20film%20still%2C%20moody%20corridor%20lit%20by%20a%20single%20lamp%20with%20camera%20rig%20silhouette%2C%20cold%20blue%20shadows%20with%20amber%20edge%20light%2C%20tense%20atmospheric%20production%20scene%2C%20highly%20detailed&width=800&height=500&seq=news-cover-004&orientation=landscape",
    date: "2025-10-11",
    category: "幕后揭秘",
    author: "幕后小组",
    views: 244,
    tags: ["暗夜追凶", "悬疑", "幕后"],
    content: [
      "随着《暗夜追凶》剧情进入高潮，剧组近日公布了幕后制作特辑，向观众展示了这部剧的创作过程。",
      "据制片方介绍，剧本历经多次打磨，仅核心案件的逻辑线就推翻重来了三稿，力求每一个线索都能经得起观众推敲。",
      "在场景搭建上，剧组搭建了长达百米的长廊实景，通过灯光与镜头的配合，营造出压迫感十足的视觉氛围。",
      "正是因为对细节的坚持，这部剧才能在众多悬疑作品中脱颖而出，成为年度口碑之作。",
    ],
  },
  {
    id: "n005",
    title: "音乐盛典《星光大赏》官宣阵容，这一季看点十足",
    summary: "节目公布首轮嘉宾阵容，多位实力唱将与新锐音乐人将同台竞演，舞台规格全面升级。",
    cover: "https://readdy.ai/api/search-image?query=Dazzling%20music%20awards%20stage%20with%20golden%20spotlights%20and%20light%20beams%2C%20performer%20silhouette%20surrounded%20by%20warm%20amber%20glow%20against%20deep%20navy%2C%20glamorous%20concert%20editorial%20photo%2C%20highly%20detailed&width=800&height=500&seq=news-cover-005&orientation=landscape",
    date: "2025-10-10",
    category: "综艺精选",
    author: "乐评小分贝",
    views: 331,
    tags: ["星光大赏", "音乐", "阵容"],
    content: [
      "作为年度备受期待的音乐盛典，《星光大赏》近日正式官宣首轮嘉宾阵容，引发广泛讨论。",
      "本季节目在赛制上进行了升级，除常规竞演外，还增设了跨界合作舞台，让不同风格的音乐人有机会同台碰撞。",
      "舞美方面，节目组启用了全新的环形舞台与沉浸式灯光系统，力求为观众带来更具冲击力的视听体验。",
      "一位节目导演透露：我们希望观众不仅听到好歌，更能看到音乐人之间真实的交流与成长。",
    ],
  },
  {
    id: "n006",
    title: "从《茶馆旧事》看年代剧的情感表达：慢一点，反而更动人",
    summary: "这部跨越半个世纪的作品，用一间茶馆串联起几代人的命运，成为年代剧中的口碑标杆。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20vintage%20teahouse%20interior%20with%20steam%20and%20wooden%20furniture%2C%20storyteller%20on%20a%20small%20stage%2C%20sepia%20and%20deep%20navy%20tones%2C%20nostalgic%20cinematic%20film%20still%2C%20highly%20detailed&width=800&height=500&seq=news-cover-006&orientation=landscape",
    date: "2025-10-09",
    category: "深度评论",
    author: "光影观察员",
    views: 189,
    tags: ["茶馆旧事", "年代剧", "评论"],
    content: [
      "在追求快节奏的当下，年代剧《茶馆旧事》却用近乎固执的缓慢，讲完了一个横跨半个世纪的故事。",
      "全片几乎没有激烈的戏剧冲突，冲突都藏在人物的沉默与眼神里。掌柜的一杯茶、一句闲话，往往比呐喊更有力量。",
      "这种叙事上的克制，恰恰是年代剧最珍贵的品质。它相信观众，也尊重生活的本来面目。",
      "当镜头最终定格在那间逐渐空下来的茶馆，许多观众表示久久无法平静。好的作品，总能在落幕之后继续生长。",
    ],
  },
  {
    id: "n007",
    title: "《都市捕手》单元剧模式获好评，刑侦题材还能怎么拍",
    summary: "该剧以单元案件串联主线的方式，兼顾了单集的紧凑与长线的悬念，为同类题材提供了新思路。",
    cover: "https://readdy.ai/api/search-image?query=Modern%20city%20skyline%20at%20night%20with%20a%20lone%20detective%20silhouette%20on%20a%20rooftop%2C%20cold%20navy%20blue%20with%20warm%20amber%20city%20lights%2C%20tense%20urban%20cinematic%20film%20still%2C%20highly%20detailed&width=800&height=500&seq=news-cover-007&orientation=landscape",
    date: "2025-10-08",
    category: "剧集观察",
    author: "爱妻艺编辑部",
    views: 213,
    tags: ["都市捕手", "刑侦", "单元剧"],
    content: [
      "刑侦剧一直是国产剧的重要类型，如何在众多作品中拍出新意，是创作者面临的共同命题。《都市捕手》给出的答案是：单元剧结构。",
      "每一集聚焦一桩案件，同时用一条主线把这些案件串联起来。这样的结构既保证了单集的观赏性，也让整个故事保持了长线悬念。",
      "更重要的是，剧集没有把重心完全放在破案过程上，而是更多着墨于人。凶手为什么这么做，受害者的处境如何，这些都让案件有了温度。",
      "有评论认为，这种以人为核心的创作思路，或许正是刑侦题材突破同质化的关键。",
    ],
  },
  {
    id: "n008",
    title: "冷门佳作《夏日回响》重映，青春片的情感密码被重新解读",
    summary: "时隔两年，这部小成本青春片以修复版重映，唤起了一批观众对青春记忆的共鸣。",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20seaside%20pier%20at%20golden%20sunset%20with%20two%20teenager%20silhouettes%2C%20warm%20amber%20light%20and%20soft%20pastel%20sky%2C%20bittersweet%20summer%20cinematic%20film%20still%2C%20highly%20detailed&width=800&height=500&seq=news-cover-008&orientation=landscape",
    date: "2025-10-07",
    category: "电影速递",
    author: "光影观察员",
    views: 156,
    tags: ["夏日回响", "青春片", "重映"],
    content: [
      "两年前上映时反响平平的青春片《夏日回响》，近日以修复版重返大银幕，意外收获了一批新观众。",
      "影片没有狗血的剧情，也没有刻意的煽情，只是安静地讲述两个少年在一个夏天里的相遇与告别。",
      "有观众在社交平台写道：以前觉得太平淡，现在才明白，平淡的才是青春本来的样子。",
      "或许，有些作品需要时间来验证。当观众的心境变了，同一部电影也会呈现出完全不同的模样。",
    ],
  },
  {
    id: "n009",
    title: "综艺市场观察：2025年，观众到底想看什么",
    summary: "从竞技到慢综艺，从音乐到美食，今年的综艺市场呈现出明显的情绪化与垂直化趋势。",
    cover: "https://readdy.ai/api/search-image?query=Colorful%20television%20studio%20with%20multiple%20screens%20and%20warm%20stage%20lights%2C%20deep%20navy%20background%20with%20amber%20and%20orange%20accents%2C%20modern%20editorial%20photo%20of%20a%20variety%20show%20set%2C%20highly%20detailed&width=800&height=500&seq=news-cover-009&orientation=landscape",
    date: "2025-10-06",
    category: "行业观察",
    author: "爱妻艺编辑部",
    views: 178,
    tags: ["综艺", "行业", "趋势"],
    content: [
      "回顾今年的综艺市场，一个明显的变化是：观众的口味正在变得更加细分化。",
      "竞技类节目依然有其稳定的受众，但慢综艺、美食综艺、旅综等强调情绪价值的品类，正在快速增长。",
      "与此同时，垂直领域的深耕成为共识。说唱、舞蹈、脱口秀等垂类节目，虽然受众规模不及全民爆款，但用户黏性更强。",
      "业内人士认为，未来综艺的竞争，将从拼明星、拼大制作，转向拼真实、拼共鸣、拼长期陪伴。",
    ],
  },
  {
    id: "n010",
    title: "《山海归途》票房破十亿，现实主义题材迎来高光时刻",
    summary: "这部取材于真实故事的电影，用细腻的情感与辽阔的风景，打动了无数观众。",
    cover: "https://readdy.ai/api/search-image?query=Epic%20wide%20shot%20of%20a%20traveler%20walking%20a%20mountain%20ridge%20above%20a%20sea%20of%20clouds%20at%20dawn%2C%20deep%20navy%20sky%20with%20warm%20amber%20light%2C%20painterly%20cinematic%20film%20still%2C%20highly%20detailed&width=800&height=500&seq=news-cover-010&orientation=landscape",
    date: "2025-10-05",
    category: "电影速递",
    author: "光影观察员",
    views: 295,
    tags: ["山海归途", "票房", "现实主义"],
    content: [
      "上映不到三周，《山海归途》票房正式突破十亿大关，成为今年现实主义题材中的一匹黑马。",
      "影片取材于真实故事，讲述一位少年穿越山海寻找归途的旅程。没有宏大的特效，却用最朴素的情感击中了观众。",
      "有影评人指出，这部电影的成功，说明观众对真诚的创作始终抱有热情。所谓现实主义，不是堆砌苦难，而是看见普通人的光。",
      "制片方表示，未来仍将继续深耕现实题材，把更多普通人的故事搬上银幕。",
    ],
  },
  {
    id: "n011",
    title: "《仙途问心》特效镜头曝光，国风仙侠的想象力边界",
    summary: "该剧公布的特效制作片段显示，团队在东方美学与视效技术的结合上做了大量尝试。",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20xianxia%20fantasy%20scene%2C%20floating%20mountain%20peaks%20above%20a%20sea%20of%20clouds%20with%20glowing%20celestial%20runes%2C%20deep%20indigo%20with%20jade%20and%20warm%20gold%20accents%2C%20ethereal%20cinematic%20visual%20effects%20still%2C%20highly%20detailed&width=800&height=500&seq=news-cover-011&orientation=landscape",
    date: "2025-10-04",
    category: "幕后揭秘",
    author: "幕后小组",
    views: 202,
    tags: ["仙途问心", "仙侠", "视效"],
    content: [
      "仙侠剧《仙途问心》近日公布了部分特效制作片段，展示了云雾、剑光与法阵等场景的呈现方式。",
      "制作团队透露，为了避免特效堆砌，他们在设计上更强调东方留白与意境，而非一味追求视觉轰炸。",
      "例如剧中反复出现的云海与远山，就参考了大量传统山水画的构图方式，让画面在奇幻之外保留了东方的含蓄。",
      "这种对美学的坚持，也让这部剧在同类作品中拥有了较为鲜明的辨识度。",
    ],
  },
  {
    id: "n012",
    title: "盘点五部值得二刷的高分剧集，剧荒时收好这份片单",
    summary: "从年代剧到悬疑剧，从都市生活到古装权谋，这份片单覆盖了多种口味，适合慢慢品味。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20editorial%20flat%20lay%20of%20a%20film%20viewing%20setup%2C%20warm%20amber%20lamp%20glow%20over%20a%20sofa%20and%20stacked%20movie%20posters%2C%20deep%20navy%20tones%2C%20inviting%20cinematic%20mood%2C%20highly%20detailed&width=800&height=500&seq=news-cover-012&orientation=landscape",
    date: "2025-10-03",
    category: "片单推荐",
    author: "爱妻艺编辑部",
    views: 412,
    tags: ["片单", "推荐", "剧荒"],
    content: [
      "剧荒的时候，与其盲目试错，不如翻开一份经过挑选的片单。以下五部剧集，都是各自类型中的代表作。",
      "《茶馆旧事》以一间茶馆串联三代人，是年代剧中的口碑之作；《暗夜追凶》则以缜密的逻辑与压抑的氛围，成为悬疑迷的心头好。",
      "如果偏爱温情，《人间烟火录》用深夜面馆里的人情故事治愈了无数观众；喜欢仙侠的，《仙途问心》在视觉与意境上都颇具诚意。",
      "而《岁月长歌》作为家庭年代剧，写尽了一个普通家庭四十年的悲欢，适合和家人一起慢慢看。",
      "好作品经得起反复观看。希望这份片单，能陪你度过每一个闲暇的夜晚。",
    ],
  },
];